import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Sorted = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="sorted icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 0C1.79086 0 0 1.79086 0 4L0 20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0L4 0ZM3.5 6.98199C3.5 6.15357 4.17157 5.48199 5 5.48199H19C19.8284 5.48199 20.5 6.15357 20.5 6.98199C20.5 7.81042 19.8284 8.48199 19 8.48199H5C4.17157 8.48199 3.5 7.81042 3.5 6.98199ZM8 10.482C7.17157 10.482 6.5 11.1536 6.5 11.982C6.5 12.8104 7.17157 13.482 8 13.482H16C16.8284 13.482 17.5 12.8104 17.5 11.982C17.5 11.1536 16.8284 10.482 16 10.482H8ZM11 15.482C10.1716 15.482 9.5 16.1536 9.5 16.982C9.5 17.8104 10.1716 18.482 11 18.482H13C13.8284 18.482 14.5 17.8104 14.5 16.982C14.5 16.1536 13.8284 15.482 13 15.482H11Z"
    />
  </svg>
)
